export default {
  material_kinds: {
    1: 'Изображение',
    2: 'Ссылка',
    3: 'Документ',
    4: 'Видео',
  },
}
